import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import "./MyProject.css";
import {
  FaHome,
  FaFolder,
  FaFileAlt,
  FaSignOutAlt,
  FaUser,
} from "react-icons/fa";
import { MdPersonSearch } from "react-icons/md";
import { MdMode } from "react-icons/md";
import logo from "../../../assets/irc-logo-rb.png";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../shared/Sidebar";

const MyProject = () => {
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("competition");

  const handleToggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const notifySuccess = (message) => toast.success(message);
  const notifyError = (message) => toast.error(message);

  useEffect(() => {
    const fetchProjects = async () => {
      const idchercheur = Cookies.get("idchercheur")
        ? parseInt(Cookies.get("idchercheur"))
        : null;
      const idevaluateur = Cookies.get("idevaluateur")
        ? parseInt(Cookies.get("idevaluateur"))
        : null;

      try {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const response = await axios.get(
          `${baseUrl}/MyProject.php?action=getUserProjects&idchercheur=${idchercheur}&idevaluateur=${idevaluateur}`
        );

        console.log("API Response:", response.data); // Debugging log

        if (response.data.status === "success") {
          notifySuccess("Projets récupérés avec succès !");
          console.log("Fetched projects:", response.data.data); // Debugging log
          setProjects(response.data.data); // Ensure projects include budgetParametreId and idcompetition
        } else {
          notifyError("Échec de la récupération des projets : " + response.data.message);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
        notifyError("Une erreur s'est produite lors de la récupération de vos projets.");
      }
    };

    fetchProjects();
  }, []);
  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const handleCompleteProject = (
    projectId,
    budgetParametreId,
    idcompetition
  ) => {
    console.log("Navigating to Forum_Project with:", {
      projectId,
      budgetParametreId,
      idcompetition,
    }); // Debugging log

    navigate("/Forum_ProjectChercheur", {
      state: {
        projectId,
        budgetParametreId,
        idcompetition,
        hideCreateButton: true, // Pass the flag
        fromMyProject: true, // Indicate navigation from MyProject.jsx
      },
    });
  };

  return (
    <div className="my-project-wrapper">
      {/* Toast Container */}
      <ToastContainer />
      {/* Sidebar */}
      <Sidebar
        onHomeClick={handleToggleSidebar}
        useLogoutHelper={false}
      />

      {/* Main Content */}
      <div className="my-project-content">
        <h2 className="title">Mes Projets</h2>
        {projects.length > 0 ? (
          <div className="project-table-wrapper">
            <table className="project-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Titre</th>
                  <th>Statut</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((project) => (
                  <tr key={project.idprojet}>
                    <td data-label="ID">{project.idprojet}</td>
                    <td data-label="Titre">
                      {project.titre_projet || "Titre Projet"}
                    </td>
                    <td
                      data-label="Statut"
                      className={
                        project.isComplete
                          ? "status-completed"
                          : "status-not-completed"
                      }
                    >
                      {project.isComplete ? "Terminé" : "Non terminé"}
                    </td>
                    <td data-label="Actions">
                      <button
                        className="complete-button"
                        onClick={() =>
                          handleCompleteProject(
                            project.idprojet,
                            project.budgetParametreId || 0, // Ensure a default value if undefined
                            project.idcompetition || 0 // Ensure a default value if undefined
                          )
                        }
                      >
                        {project.isComplete
                          ? "Voir le projet"
                          : "Compléter le projet"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="no-projects">Aucun projet trouvé.</p>
        )}
      </div>
    </div>
  );
};

export default MyProject;
